'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var FILE = exports.FILE = ['file'];

var LOCAL_ID = exports.LOCAL_ID = ['localId'];

var FILE_ID = exports.FILE_ID = ['fileId'];

var UPLOAD_PROGRESS = exports.UPLOAD_PROGRESS = ['uploadProgress'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-internal-schema/static-1.4266/js/file-upload/constants/fileUploadKeyPaths.js
// module id = 452
// module chunks = 2 3